'use client';

import { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import noop from 'lodash/noop';

export const WindowLoadedContext = createContext(false);

export interface WindowLoadedContextProviderProps {
  children: ReactNode;
}

let isWindowLoaded = false;

export default function WindowLoadedContextProvider({ children }: WindowLoadedContextProviderProps) {
  const [loaded, setLoaded] = useState(isWindowLoaded);

  useEffect(() => {
    const onLoad = () => {
      setLoaded(true);
      isWindowLoaded = true;
    };
    if (typeof window !== 'undefined' && document.readyState === 'complete') {
      onLoad();
      return noop;
    }
    window.addEventListener('load', onLoad);
    return () => {
      window.removeEventListener('load', onLoad);
    };
  }, []);
  return <WindowLoadedContext.Provider value={loaded}>{children}</WindowLoadedContext.Provider>;
}

export const useWindowLoaded = (): boolean => useContext(WindowLoadedContext);
